<template>
<div name="student">

    <MobileHeader></MobileHeader>
    <div class="d-flex flex-row flex-column-fluid page">
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">

            <Header></Header>

            <!--begin::Content-->
            <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
                <!--begin::Entry-->
                <div class="d-flex flex-column-fluid">
                    <!--begin::Container-->
                    <!--begin::Dashboard-->

                    <div class="container">
                        <div class="card card-custom gutter-b">
                            <!--begin::Body-->
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-xl-6">
                                        <div class="form-group">
                                            <label>KPI Name</label>
                                            <input type="text" disabled class="form-control form-control-solid form-control-lg" v-model="kpi_name" placeholder="Titles">
                                        </div>
                                    </div>

                                    <div class="col-xl-6">
                                        <div class="form-group">
                                            <label>Team Name</label>
                                            <select class="form-control form-control-solid form-control-lg" disabled v-model="tid">
                                                <option value="">Select Team</option>
                                                <template v-for="tdata in teamData">
                                                    <option :key="tdata.id" :value="tdata.id">{{tdata.name}}</option>
                                                </template>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-6">
                                        <div class="form-group">
                                            <label>Select Progress Indiactor</label>
                                            <select :class="'form-control form-control-solid form-control-lg '+color_set" disabled v-model="progress">
                                                <option value="">Select Progress Indiactor Type</option>
                                                <option value="30">Inccomplete 0-30%</option>
                                                <option value="70">Progressing 30%-70%</option>
                                                <option value="95">Progressing 70%-95%</option>
                                                <option value="100">Progressing 100% </option>

                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-6">
                                        <div class="form-group">
                                            <label>Select Quarter Type</label>
                                            <select class="form-control form-control-solid form-control-lg" disabled v-model="quarter">
                                                <option value="">Select Quarter Type</option>
                                                <option value="January-March">January-March</option>
                                                <option value="April-June">April-June </option>
                                                <option value="July-September">July-September</option>
                                                <option value="October-December">October-December</option>

                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <label>Objective</label>
                                        <div class="form-group">
                                            <vue-editor disabled v-model="description"></vue-editor>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <label>Key Results</label>
                                        <div class="form-group">
                                            <vue-editor disabled v-model="results"></vue-editor>
                                        </div>
                                    </div>
                                </div>

                            </div>
                           

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from 'axios'
import MobileHeader from '../../components/MobileHeader'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import {
    VueEditor
} from "vue2-editor";

export default {
    name: 'ViewKpis',
    components: {
        Header,
        Footer,
        MobileHeader,
        VueEditor,
    },
    data() {
        return {
            uid: localStorage.getItem("uid"),
            role: localStorage.getItem("role"),
            allData: [],
            kpi_name: null,
            tid: "",
            description: null,
            teamData: [],
            quarter: "",
            results: null,
            progress: "",
            color_set:null,
        }
    },
    mounted() {
        if (this.uid == null || this.uid == "") {
            this.$router.push("/");
        }
        this.allTeam();
        this.getSchedule();
    },
    methods: {
        allTeam() {
            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'lms_api.php',
                data: {
                    type: 'team_all_data',
                }
            }).then(function (response) {
                var data = response.data;
                ev.teamData = data;

            })
        },
        getSchedule() {
            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'lms_api.php',
                data: {
                    type: 'getByIdKpis',
                    kid: this.$route.params.id,
                    
                }
            }).then(function (response) {
                var data = response.data;
                //console.log(data);
                ev.kpi_name=data.kpi_name;
                ev.tid=data.tid;
                ev.description=data.objective;
                ev.results=data.results;
                ev.quarter=data.quarter;
                ev.progress=data.progress;

                if(ev.progress==30){
                    ev.color_set='first30';
                }else if(ev.progress==70){
                    ev.color_set='sec70';
                }else if(ev.progress==90){
                    ev.color_set='trd90';
                }else if(ev.progress==100){
                    ev.color_set='for100';
                }
                
            })
        }
    },
}
</script>

<style scoped>
.first30{
    background: #F55A5A;
}
.sec70{
    background: #FDBD7C;
}
.trd90{
    background: #FFE599;
}
.for100{
   background: #7ADB77;
}
.btn-top-table {
    display: inline-block;
    padding: 10px;
    width: 50%;
}

.table {
    width: 100%;

}

.table-dt {
    overflow: scroll;
}

.tbl-action {
    margin: 2px;
    border: unset;
}
</style>
